import { useTranslation } from 'react-i18next';

const FamilyBuildingAdoptionTimeline = ({ prevStep, handleChange, formData, nextStep, error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="step-section">
        <div className="adoption-journey-label">Adoption Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">Is there a timeline you're working toward?</h3>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionTimeline"
            id="adoptionTimeline1"
            value="Within 6 months"
            checked={formData.AdoptionTimeline === "Within 6 months"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionTimeline1" className="multistep-form-radio-checkbox-label">Within 6 months</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionTimeline"
            id="adoptionTimeline2"
            value="6-12 months"
            checked={formData.AdoptionTimeline === "6-12 months"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionTimeline2" className="multistep-form-radio-checkbox-label">6-12 months</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionTimeline"
            id="adoptionTimeline3"
            value="12+ months"
            checked={formData.AdoptionTimeline === "12+ months"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionTimeline3" className="multistep-form-radio-checkbox-label">12+ months</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionTimeline"
            id="adoptionTimeline4"
            value="No specific timeline"
            checked={formData.AdoptionTimeline === "No specific timeline"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionTimeline4" className="multistep-form-radio-checkbox-label">No specific timeline</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
  {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingAdoptionTimeline;
